import { render, staticRenderFns } from "./scrollTabAux.vue?vue&type=template&id=16bc0e34&scoped=true&"
import script from "./scrollTabAux.vue?vue&type=script&lang=js&"
export * from "./scrollTabAux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bc0e34",
  null
  
)

export default component.exports